import script from "./CreateHeaderEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateHeaderEvent.vue?vue&type=script&setup=true&lang=ts"

import "./CreateHeaderEvent.vue?vue&type=style&index=0&id=fe15b7c4&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe15b7c4"]])

export default __exports__